import React from 'react';
import PropTypes from 'prop-types';

import {greyishBlue600} from "assets/jss/main";

import {UserAgentUtils} from "utils/useragent";

Subtitle.propTypes = {
    children: PropTypes.node,
};

function Subtitle(props) {
    if (!props.children) {
        return null;
    }

    const isMobile = UserAgentUtils.isMobile();

    return (
        <div style={{
            color: greyishBlue600,
            fontSize: isMobile ? '11px' : '14px',
            marginTop: "4px",
            lineHeight: 'normal'
        }}>
            {props.children}
        </div>
    );
}

export default Subtitle;
